import { render, staticRenderFns } from "./LoginWx.vue?vue&type=template&id=42208aea&scoped=true"
import script from "./LoginWx.vue?vue&type=script&lang=js"
export * from "./LoginWx.vue?vue&type=script&lang=js"
import style0 from "./LoginWx.vue?vue&type=style&index=0&id=42208aea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42208aea",
  null
  
)

export default component.exports